import SEO from "./SEO";
import Layout from "./layout";

export { Layout, SEO };
